import type { Tour } from '../tour-types';

/**
 * The Brief tab of an experiment (`?screen=info`): the case for the test. Importance shows
 * either a prompt or the finished PXL score, and both carry the anchor. The run length card
 * is missing on an experiment that started without a plan, and its step drops out there.
 */
export const experimentBriefTour: Tour = {
  key: 'experiments.brief',
  version: 1,
  routes: ['/experiments/:id'],
  screen: 'info',
  steps: [
    {
      anchor: 'brief-importance',
      placement: 'right',
      title: 'Importance',
      body: 'Rate the idea with the PXL framework: its potential, how many visitors see it, and the effort it takes. The score helps decide which test to run first, and the Program screen groups results by it.',
    },
    {
      anchor: 'brief-plan',
      placement: 'right',
      title: 'Run length',
      body: 'How long the test needs to run to detect the lift you care about, from your traffic and conversion rate. Plan it while the experiment is a draft; once it runs, live progress is on the Statistics tab.',
    },
    {
      anchor: 'brief-hypothesis',
      placement: 'left',
      title: 'Hypothesis',
      body: 'What you expect to happen and why. The Debrief tab puts it next to the result, so write it before the test starts.',
    },
    {
      anchor: 'brief-mechanisms',
      placement: 'left',
      title: 'Expected mechanisms',
      body: 'Why the change should work, picked from a list or written under Other. Hover a mechanism to see what it means.',
    },
    {
      anchor: 'brief-description',
      placement: 'top',
      title: 'Description and notes',
      body: 'Anything else the team should know: the background, links, decisions made along the way.',
    },
    {
      anchor: 'brief-screenshots',
      placement: 'top',
      title: 'Variant previews',
      body: 'Screenshots captured in the visual editor, one tab per variant. Open one full size, add a comment to it, or download it.',
    },
  ],
};
